export * from './getLogoSrc';
